import { Route } from '../../route.model';
import LoyaltyRewards from '@/views/Portal/LoyaltyRewards.vue';

const portalLoyaltyRewards = new Route(
  '/portal/loyalty-rewards',
  'portal-loyalty-rewards',
  LoyaltyRewards,
  {
    requiresAuth: true,
    isResponsive: true,
    zendesk: {
      disabled: true
    }
  }
);

export { portalLoyaltyRewards };
export default portalLoyaltyRewards;
